import React, { useEffect, useState } from "react";

import Header from "../home/header";
import Loading from "../home/Loading";
import { useLocation, useNavigate } from "react-router";
import UTILS from "../../utils/commons";
import { ApiClient } from "../../utils/api-client";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { AxiosError } from 'axios'


const PaymentForm = props => {
    var navigate = useNavigate();
    const loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
    const apiClient = new ApiClient( loginState ? loginState.accessToken : null );

    const [ isLoading, setIsLoading ] = useState( false );
    const [ feedback, setFeedback ] = useState( "" );
    const [ inventory, setInventory ] = useState( [] );
    const [ customers, setCustomers ] = useState( [] );
    const [ suppliers, setSuppliers ] = useState( [] );
    const [ selectedSupplier, setSelectedSupplier ] = useState( null )
    const [ customerDebt, setCustomerDebt ] = useState( null )
    const [ amountExceedsDebt, setAmountExceedsDebt ] = useState( false )
    const paymentTypes = [
        { id: 0, text: "Payment from creditors" },
    ]
    if ( loginState.role === UTILS.ADMIN ) {
        paymentTypes.push( { id: 1, text: "Payment to suppliers" } );
        // paymentTypes.push( { id: 2, text: "Operational Expenses" } )
    }


    const loadData = async () => {
        try {
            const [ custRes, invRes ] = await Promise.all( [
                apiClient.get( loginState.role === UTILS.ADMIN ? "customers" : `customers/profile/${loginState.profile.id}` ),
                apiClient.get( loginState.role === UTILS.ADMIN ? "inventory" : `issues/profile/${loginState.profile.id}` ),
            ] );
            if ( custRes.status === 200 && custRes.data ) {
                setCustomers( custRes.data );
            }
            if ( invRes.status === 200 && invRes.data ) {
                const inv = invRes.data
                setInventory( inv );
                const uniqueSuppliers = Array.from(
                    new Map(
                        inv
                            .filter( iv => ( Number( iv?.cifCost || 0 ) - Number( iv?.amountPaid || 0 ) ) > 0 )
                            .filter( iv => iv?.supplier?.id )
                            .map( iv => [ iv.supplier.id, iv.supplier ] )
                    ).values()
                );
                setSuppliers( uniqueSuppliers );
            }
        }
        catch ( e ) {
            console.log( "Error loading data: ", e );
        }
    }
    const handleFileChange = ( e ) => {
        const file = e.target.files[ 0 ];
        if ( file ) {
            const reader = new FileReader()
            reader.onload = () => {
                const url = URL.createObjectURL( file );
                formik.setFieldValue( "file", reader.result );
            };
            reader.readAsDataURL( file );
        }
        else setFeedback( "Please select a file" );
    }

    // Helper to format number with commas
    const formatNumberWithCommas = ( value ) => {
        if ( value === null || value === undefined ) return '';
        const parts = value.toString().split( "." );
        parts[ 0 ] = parts[ 0 ].replace( /\B(?=(\d{3})+(?!\d))/g, "," );
        return parts.join( "." );
    };

    // Handler for amount input with formatting
    const handleAmountChange = ( e ) => {
        let input = e.target.value.replace( /,/g, '' ); // Remove commas
        // Only allow numbers and optional decimal
        if ( !/^\d*(\.\d*)?$/.test( input ) ) return;
        // Validate against customer debt when paying creditors
        if ( formik.values.type == 0 && customerDebt !== null ) {
            setAmountExceedsDebt( Number( input ) > customerDebt );
        }
        // Update Formik with raw value
        formik.setFieldValue( 'amount', input );
    };
    useEffect( () => {
        loadData();
    }, [] )
    const formik = useFormik( {
        initialValues: {
            type: paymentTypes[ 0 ].id,
            paymentDate: '',
            customerId: null,
            supplierId: null,
            invoiceNumber: '',
            amount: '',
            file: null,
            paidTo: '',
            reason: '',
        },
        validationSchema: Yup.object( {
            type: Yup.number().required(),
            paymentDate: Yup.string().required( 'Date is required' ),
            amount: Yup.string().required( 'Amount is required' ),
            file: Yup.mixed().required( 'Supporting document is required' ),
            paidTo: Yup.string().when( [ "type" ], {
                is: ( type ) => loginState.role === UTILS.ADMIN && Number( type ) === 2,
                then: schema => schema.required( 'Paid To is required' ),
                otherwise: schema => schema.notRequired()
            } ),
            reason: Yup.string().when( [ "type" ], {
                is: ( type ) => loginState.role === UTILS.ADMIN && Number( type ) === 2,
                then: schema => schema.required( 'Reason is required' ),
                otherwise: schema => schema.notRequired()
            } ),
        } ),
        onSubmit: async ( values ) => {
            setIsLoading( true );
            const payment = {
                ...values,
                profileId: loginState.role == UTILS.SALES || loginState.role == UTILS.FINANCE || loginState.role == UTILS.STAFF ? loginState.profile.id : null,
                reason: values.type == 0 ? "Payment from credit sales" : ( values.type == 1 ? "Payment to suppliers" : values.reason ),
            }
            savePayment( payment );
        },
    } );
    //save transaction
    const savePayment = async ( payment ) => {
        console.log( "🚀 ~ savePayment ~ payment:", payment )
        try {
            const req = await apiClient.post( "/payments", payment );

            setIsLoading( false );
            if ( req.status === 201 ) {
                navigate( "/payments", { replace: true } );
            }
            else {
                setFeedback( 'Oops! Something went wrong' );
            }
        }
        catch ( e ) {
            console.log( "Error saving payment: ", e );
            setFeedback( 'Oops! Something went wrong' );
            setIsLoading( false );
            if ( e instanceof AxiosError && e.response && e.response.status === 401 ) {
                UTILS.signout();
                navigate( `/signin`, { replace: true, state: { target: '/payments/new' } } );
                return;
            }
        }

    }
    const handleCustomerChange = async ( e ) => {
        const customerId = e.target.value;
        formik.setFieldValue( "customerId", customerId );
        await getCustomerDebt( customerId )
    }

    const handleSupplierChange = ( e ) => {
        const supplierId = e.target.value.trim();
        const supplier = suppliers.find( sp => sp.id == supplierId );
        setSelectedSupplier( supplier );
        formik.setFieldValue( 'invoiceNumber', '' );
        formik.setFieldValue( 'amount', '' );

    }

    const unpaidSupplierInvoices = Object.values( inventory.reduce( ( acc, iv ) => {
        const isSelectedSupplier = iv?.supplier?.id == selectedSupplier?.id;
        const unpaidBalance = Number( iv?.cifCost || 0 ) - Number( iv?.amountPaid || 0 );
        if ( !isSelectedSupplier || unpaidBalance <= 0 ) return acc;

        const invoiceNumber = iv?.invoiceNumber;
        if ( !invoiceNumber ) return acc;

        if ( !acc[ invoiceNumber ] ) {
            acc[ invoiceNumber ] = { ...iv, unpaidBalance };
        }
        return acc;
    }, {} ) );
    const getCustomerDebt = async ( customerId ) => {
        try {
            const req = await apiClient.get( `/payments/customer-debt/${customerId}` );
            const debt = req.data.debt ? Number( req.data.debt ) : 0;
            setCustomerDebt( debt );
            setAmountExceedsDebt( false );
            // Set as raw number (no commas)
            formik.setFieldValue( "amount", debt ? debt.toString() : "" );
        }
        catch ( e ) {
            setFeedback( "Failed to get customer debt" )
        }
    }

    useEffect( () => {

    }, [] )


    return (
        <>
            <Header auth={loginState} />
            <section className="flex justify-start items-start">
                <div className="container mx-auto md:mt-8">
                    {feedback.length > 0 ? <div className="w-10/12 md:w-8/12 mx-auto mb-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-red-700 text-sm" id="form-feedback">{Object.keys( formik.errors ).join( ", " )}</div> : null}
                    <div className="md:w-10/12 md:mx-auto rounded-xl border border-gray-200 bg-white shadow-md pt-10 px-3 md:px-6">
                        <div className="text-center mx-auto w-full">
                            <p className="text-sm uppercase tracking-wide text-gray-500 text-center">Payment Setup</p>
                            <p className="text-center text-2xl font-semibold text-gray-800 my-3">Register a Payment</p>
                            <form id="payment_form" className=" text-start w-full md:w-9/12 mx-auto mb-16" onSubmit={formik.handleSubmit}>
                                <div className="flex flex-col justify-evenly w-full mx-auto px-4 ">
                                   
                                   
                                    {/* ...existing code... */}
                                    <div className="form-group my-2 w-full md:w-8/12 lg:w-8/12 mx-auto">
                                        <label htmlFor="type">Payment Type</label>
                                        <select className="form-control" id="type" name="type" value={formik.values.type} onChange={formik.handleChange}>
                                            {paymentTypes.map( pt => {
                                                return <option key={pt.id} value={pt.id}>{pt.text}</option>
                                            } )}
                                        </select>
                                        {formik.touched.type && formik.errors.type ? (
                                            <div className="text-danger small">{formik.errors.type}</div>
                                        ) : null}
                                    </div>
                                    <div className="form-group my-2 w-full md:w-8/12 lg:w-8/12 mx-auto">
                                        <label htmlFor="paymentDate">Date of Payment <em className="text-danger">*</em></label>
                                        <input type="date" className="form-control" id="paymentDate" name="paymentDate" value={formik.values.paymentDate} onChange={formik.handleChange} onBlur={formik.handleBlur} />
                                        {formik.touched.paymentDate && formik.errors.paymentDate ? (
                                            <div className="text-danger small">{formik.errors.paymentDate}</div>
                                        ) : null}
                                    </div>
                                </div>
                                {formik.values.type == 0 ?
                                    <div className="flex flex-col justify-evenly w-full mx-auto px-4">
                                        <div className="form-group my-2 w-full md:w-8/12 lg:w-8/12 mx-auto">
                                            <label htmlFor="customerId">Customer</label>
                                            <select className="form-control" id="customerId" name="customerId" value={formik.values.customerId} onChange={handleCustomerChange} onBlur={formik.handleBlur}>
                                                <option value="">--select customer--</option>
                                                {customers.map( c => {
                                                    return <option key={UTILS.randomKey()} value={c.id}>{c.name}</option>
                                                } )}
                                            </select>
                                            {formik.touched.customerId && formik.errors.customerId ? (
                                                <div className="text-danger small">{formik.errors.customerId}</div>
                                            ) : null}
                                        </div>
                                        <div className="form-group my-2 w-full md:w-8/12 lg:w-8/12 mx-auto"></div>
                                    </div> :
                                    ( formik.values.type == 1 ?
                                        <div className="flex flex-col justify-evenly w-full mx-auto px-4 ">
                                            <div className="form-group my-2 w-full md:w-8/12 lg:w-8/12 mx-auto">
                                                <label htmlFor="supplierId">Supplier <em className="text-danger">*</em></label>
                                                <select className="form-control" id="supplierId" name="supplierId" value={formik.values.supplierId} onChange={( e ) => { formik.handleChange( e ); handleSupplierChange( e ) }} onBlur={formik.handleBlur}>
                                                    <option value="">--select supplier--</option>
                                                    {suppliers.map( c => {
                                                        return <option key={c.id} value={c.id}>{c.companyName}</option>
                                                    } )}
                                                </select>
                                                {formik.touched.supplierId && formik.errors.supplierId ? (
                                                    <div className="text-danger small">{formik.errors.supplierId}</div>
                                                ) : null}
                                            </div>
                                            <div className="form-group my-2 w-full md:w-8/12 lg:w-8/12 mx-auto">
                                                <label htmlFor="invoiceNumber">Invoice Number<em className="text-danger">*</em></label>
                                                <select className="form-control" id="invoiceNumber" name="invoiceNumber" value={formik.values.invoiceNumber} onChange={( e ) => {
                                                    formik.handleChange( e );
                                                    const selected = unpaidSupplierInvoices.find( iv => iv.invoiceNumber === e.target.value );
                                                    if ( selected ) {
                                                        const balance = parseFloat( selected.cifCost ) - parseFloat( selected.amountPaid );
                                                        formik.setFieldValue( 'amount', balance > 0 ? balance.toString() : '0' );
                                                    } else {
                                                        formik.setFieldValue( 'amount', 0 );
                                                    }
                                                }} onBlur={formik.handleBlur}>
                                                    <option value="">--select invoice--</option>
                                                    {unpaidSupplierInvoices.map( c => {
                                                        return <option key={c.invoiceNumber} value={c.invoiceNumber}>{c.invoiceNumber}</option>
                                                    } )}
                                                </select>
                                                {formik.touched.invoiceNumber && formik.errors.invoiceNumber ? (
                                                    <div className="text-danger small">{formik.errors.invoiceNumber}</div>
                                                ) : null}
                                            </div>
                                        </div> : null )
                                }
                                <div className="flex flex-col justify-evenly w-full mx-auto px-4">
                                    <div className="form-group my-2 w-full md:w-8/12 lg:w-8/12 mx-auto">
                                        <label htmlFor="amount">Amount TZS <em className="text-danger">*</em></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="amount"
                                            name="amount"
                                            value={formatNumberWithCommas( formik.values.amount )}
                                            onChange={handleAmountChange}
                                            onBlur={formik.handleBlur}
                                            inputMode="decimal"
                                            autoComplete="off"
                                        />
                                        {formik.touched.amount && formik.errors.amount ? (
                                            <div className="text-danger small">{formik.errors.amount}</div>
                                        ) : null}
                                        {amountExceedsDebt ? (
                                            <div className="text-danger small">Amount cannot exceed the customer's outstanding debt of TZS {formatNumberWithCommas( customerDebt )}</div>
                                        ) : null}
                                    </div>
                                    {loginState.role === UTILS.ADMIN && Number( formik.values.type ) === 2 ? (
                                        <>
                                            <div className="form-group my-2 w-full md:w-8/12 lg:w-8/12 mx-auto">
                                                <label htmlFor="paidTo">Paid To <em className="text-danger">*</em></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="paidTo"
                                                    name="paidTo"
                                                    value={formik.values.paidTo}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.touched.paidTo && formik.errors.paidTo ? (
                                                    <div className="text-danger small">{formik.errors.paidTo}</div>
                                                ) : null}
                                            </div>
                                            <div className="form-group my-2 w-full md:w-8/12 lg:w-8/12 mx-auto">
                                                <label htmlFor="reason">Reason <em className="text-danger">*</em></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="reason"
                                                    name="reason"
                                                    value={formik.values.reason}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.touched.reason && formik.errors.reason ? (
                                                    <div className="text-danger small">{formik.errors.reason}</div>
                                                ) : null}
                                            </div>
                                        </>
                                    ) : null}
                                    <div className="form-group my-2 w-full md:w-8/12 lg:w-8/12 mx-auto">
                                        <label htmlFor="file">Supporting Document <em className="text-danger">*</em></label>
                                        <input type="file" className="form-control" id="file" name="file" onChange={handleFileChange} />
                                        {formik.touched.file && formik.errors.file ? (
                                            <div className="text-danger small">{formik.errors.file}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="flex justify-between w-full mx-auto px-16">
                                    {/* Hide submit if amount is 0/empty or no customer (when type 0) */}
                                    <div className="form-group my-2 w-full md:w-4/12 lg:w-3/12 mx-auto">
                                        {( () => {
                                            const amountNum = Number( ( formik.values.amount || '' ).replace( /,/g, '' ) );
                                            const isAmountInvalid = !amountNum || amountNum === 0;
                                            const isCustomerMissing = formik.values.type == 0 && !formik.values.customerId;
                                            if ( isAmountInvalid || isCustomerMissing || amountExceedsDebt ) return null;
                                            return isLoading ? <Loading /> : (
                                                <input type="submit" className="form-control bg-success" id="btnSubmit" name="btnSubmit" value="SUBMIT" />
                                            );
                                        } )()}
                                    </div>
                                    <div className="form-group my-2 w-full md:w-4/12 lg:w-3/12 mx-auto">
                                        <input onClick={() => { navigate( -1, { replace: true } ) }}
                                            type="button"
                                            className="form-control"
                                            value="Cancel"
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )

}
export default PaymentForm;
